export default __webpack_public_path__ + "static/media/strasbourg11.fdc5791d.jpg";